/// <reference path='../_all.ts' />

module training {
  'use strict';

  export class Product {
    constructor(
      public Id: number,
      public Name: string,
      public ImagePath: string,
      public TextD: string,
      public TextE: string,
      public LongDescD: string,
      public LongDescE: string,
      public LaunchDate: Date,
      public IsNew: boolean,
      public IsComingSoon: boolean,
      public IsObsolete: boolean,
      public IsTemporary: boolean,
      public CategoryId: number,
      public CategoryNameD: string,
      public CategoryNameE: string,
      public ProductImageName: string,
      public UrlD: string,
      public UrlE: string,
      public KillingDate?: Date
    ) { }
  }
}